import { useSelector } from "react-redux";

import { useUser } from "../users/hooks";

import {
  selectFormattedDualApproval,
  selectAllPendingDualApprovals,
  selectFormattedPaginatedDualApprovals,
  selectFormattedPaginatedHistoryDualApprovals,
  selectFormattedPaginatedTemplateDualApprovals,
  selectHistoryTotal,
  selectTemplateTotal,
  selectTotal,
} from "./selectors";

import type { RootState } from "../store";

export const useFormattedPaginatedDualApprovals = (pageNumber: number) => {
  return useSelector((state) =>
    selectFormattedPaginatedDualApprovals(state, pageNumber),
  );
};

export const useFormattedDualApproval = (id?: API.DualApprovalId | null) => {
  return useSelector((state: RootState) =>
    selectFormattedDualApproval(state, id),
  );
};

export const useDualApprovalTotal = () => {
  return useSelector(selectTotal);
};

export const useFormattedPaginatedHistoryDualApprovals = (
  pageNumber: number,
) => {
  return useSelector((state) =>
    selectFormattedPaginatedHistoryDualApprovals(state, pageNumber),
  );
};

export const useHistoryDualApprovalTotal = () => {
  return useSelector(selectHistoryTotal);
};

export const useFormattedPaginatedTemplateDualApprovals = (
  pageNumber: number,
) => {
  return useSelector((state) =>
    selectFormattedPaginatedTemplateDualApprovals(state, pageNumber),
  );
};

export const useTemplateDualApprovalTotal = () => {
  return useSelector(selectTemplateTotal);
};

export const useActionableDualApprovals = () => {
  const pendingDualApprovals = useSelector(selectAllPendingDualApprovals);
  const user = useUser();

  if (!user?.id) {
    return [];
  }

  const actionableDualApprovals = pendingDualApprovals.filter(
    (approvalRequest) => approvalRequest.requester.id !== user?.id,
  );

  return actionableDualApprovals;
};
